import { Outlet, useNavigate } from "react-router";
import { WorkspaceProvider } from "../providers";
import { Layout } from "../../layout";
import { ThreadSelector, ThreadExitFeedbackPrompt } from "../../thread";

interface WorkspaceScreenProps {
  children?: React.ReactNode;
  wide?: boolean;
  utilityHeader?: boolean;
}

export function WorkspaceScreen({
  children,
  wide,
  utilityHeader,
}: WorkspaceScreenProps) {
  const navigate = useNavigate();

  return (
    <Layout
      wide={wide}
      utilityHeader={utilityHeader}
      sidebarChildren={
        <WorkspaceProvider>
          <ThreadSelector
            onSelect={({ thread_id }) => {
              navigate(`/${thread_id}`);
            }}
          />
        </WorkspaceProvider>
      }
    >
      <WorkspaceProvider>
        {children || <Outlet />}
        <ThreadExitFeedbackPrompt />
      </WorkspaceProvider>
    </Layout>
  );
}
